module.exports = __webpack_public_path__ + "media/packs/landing_page/images/activities/barre-b0676bc26494b933f84f47b35dc12ff9.png";